export default {
  state: {
    highlight: {
      leg1: '',
      leg2: ''
    }
  },
  mutations: {
    setHighlight (state, data) { state.highlight[data.leg] = data.value }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/highlight.js